export class EntTerritorialUnitsFilterPoligons {
    page: number;
    size: number;
    type: string[];

    constructor(init?: Partial<EntTerritorialUnitsFilterPoligons>) {
        this.page = init?.page || 1;
        this.size = init?.size || 60;
        this.type = init?.type || ["REGION", "AREA", "CITY_OF_REPUBLICAN_SIGNIFICANCE"];
    }
}
